import React, { useState } from "react"
import { Link } from "react-router-dom"
import Logo from "./Logo"
import { footer } from "../data/footer"

const Footer = () => {
  // eslint-disable-next-line
  const [links, setLinks] = useState(footer)

  return (
    <footer className="bg-gray-900 pt-20 pb-5 px-5 md:flex md:items-center md:justify-between md:pb-20">
      <div className="flex items-center">
        <Logo />
        <h3 className="text-4xl ml-2 text-white">Swadakta</h3>
      </div>

      <ul className="my-5 md:my-0">
        {links.map((link) => {
          const { id, title, url } = link

          return (
            <li key={id} className="my-2">
              <Link to={url} className="text-white">
                {title}
              </Link>
            </li>
          )
        })}
      </ul>

      <div className="pt-10 md:pt-0">
        <h5 className="text-white">© Swadakta Security, 2021</h5>
        <h6 className="text-white mt-2 text-sm">
          Built by{" "}
          <a
            href="https://tsbsankara.co.ke"
            className="text-gray-200 hover:text-white"
          >
            Thomas Sankara
          </a>{" "}
        </h6>
      </div>
    </footer>
  )
}

export default Footer
